import { isEqual } from 'lodash';
import { getCurrentUser } from 'utils/localStorage';
import { reduce, orderBy } from 'lodash';

export const templateIdsForSubsection = (
  {
    inCartModels,
    inCartFunctionalGroups,
    modelsViewer,
    inCartTemplates,
    dashboard,
  },
  { seriesId, subsectionId },
) => {
  const currentUser = getCurrentUser();
  const lockedModelIds = Object.keys(inCartModels.byId).filter(
    modelId =>
      modelsViewer.byId[modelId] &&
      modelsViewer.byId[modelId].currentViewer &&
      !isEqual(
        modelsViewer.byId[modelId].currentViewer.userId,
        currentUser.userId,
      ),
  );

  let templateIds;

  if (dashboard.brand === 'MI') {
    const prefilterTemplateIds = Object.values(inCartTemplates.byId).filter(
      template =>
        inCartModels.byId[template.modelId] &&
        inCartModels.byId[template.modelId].seriesId === seriesId &&
        template.modelId === subsectionId,
    );
    templateIds = orderBy(
      prefilterTemplateIds,
      ['functionalGroupId'],
      ['asc'],
    ).map(template => template.id);
  } else {
    const prefilterTemplateIds = Object.values(inCartTemplates.byId).filter(
      template =>
        template.seriesId === seriesId &&
        inCartModels.byId[template.modelId].bodyStyleId === subsectionId,
    );
    templateIds = orderBy(
      prefilterTemplateIds,
      ['functionalGroupId'],
      ['asc'],
    ).map(template => template.id);
  }

  const unlockedTemplateIds = templateIds.filter(
    templateId =>
      !lockedModelIds.includes(inCartTemplates.byId[templateId].modelId),
  );
  return {
    templateIdsInOrder: templateIds,
    unlockedTemplateIds: unlockedTemplateIds,
  };
};

export const inCartTemplate = ({ inCartTemplates }, { templateId }) =>
  inCartTemplates.byId[templateId];

export const inCartQuantityForSubsection = (
  { inCartTemplates },
  { templateIdsInOrder },
) =>
  templateIdsInOrder.reduce((total, templateId) => {
    let template = inCartTemplates.byId[templateId];
    let templateSum = reduce(
      template.prioritiesToQuantitiesMap,
      function(result, value, key) {
        return result + value;
      },
      0,
    );
    return (total += templateSum);
  }, 0);

export const selected = ({ inCartTemplates }, { templateId }) => {
  const template = inCartTemplates.byId[templateId];
  if (template) {
    return template.selected;
  }
};

export const locked = ({ inCartTemplates, modelsViewer }, { templateId }) => {
  const template = inCartTemplates.byId[templateId];
  if (template) {
    const currentUser = getCurrentUser();

    if (modelsViewer) {
      const modelViewer = modelsViewer.byId[template.modelId];
      if (
        modelViewer &&
        modelViewer.currentViewer &&
        !isEqual(modelViewer.currentViewer.userId, currentUser.userId)
      ) {
        return true;
      }
    }
  }
  return false;
};
